import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '../services/language.service';

/** Attaches the active UI language as Accept-Language on every outgoing request — mirrors
 *  fe-flight-fusion-web's jwtInterceptor pattern, so search/price/reservation calls get
 *  content back in the agent's chosen language without every call site setting it manually. */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const lang = inject(LanguageService).lang();
  return next(req.clone({ setHeaders: { 'Accept-Language': lang } }));
};
